import { useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { LARVA_WS } from '../../../core/datasets/action';
import { Capacitor } from '@capacitor/core';
import { App, AppState } from '@capacitor/app';
import WebsocketErrorService from 'smartHome/larva/classes/WebsocketErrorService';

const errorService = WebsocketErrorService.getInstance();

function useLarvaVisibilityWatch(): void {
    const dispatch = useDispatch();

    const changeWebsocketConnections = useCallback(
        (isHidden) => {
            if (isHidden) {
                dispatch({ type: LARVA_WS.DISCONNECT_ALL });
            } else {
                dispatch({ type: LARVA_WS.CONNECT_ALL });
            }
        },
        [dispatch],
    );

    useEffect(() => {
        const larvaWebsocketsListener = () => {
            changeWebsocketConnections(document.hidden);
        };

        const larvaWebsocketsListenerNative = (state: AppState) => {
            changeWebsocketConnections(!state.isActive); // i.e. is hidden
        };

        if (Capacitor && Capacitor.isNativePlatform()) {
            App.addListener('appStateChange', larvaWebsocketsListenerNative).catch(errorService.handleError);
        } else {
            document.addEventListener('visibilitychange', larvaWebsocketsListener);
        }

        return () => {
            if (!Capacitor || !Capacitor.isNativePlatform()) {
                document.addEventListener('visibilitychange', larvaWebsocketsListener);
            }
        };
    }, [changeWebsocketConnections, dispatch]);
}

export default useLarvaVisibilityWatch;
